import type { components } from '@pba/types-openapi-client';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type CommentResponse = components['schemas']['Comment'];

type EditCommentRequest = {
  /* eslint-disable @typescript-eslint/naming-convention -- Start: Keys are defined by Backend API endpoint */
  content_object: {
    attachments?: Array<{ id: string }>;
    html_content?: string;
    id: string;
    parent_id: string;
    text_content?: string;
  };
  /* eslint-enable @typescript-eslint/naming-convention -- End: Keys are defined by Backend API endpoint */
};

export const editComment = async (data: EditCommentRequest) =>
  apiClient.put<CommentResponse, ApiClientResponse<CommentResponse>>(
    routes.contentObjects.comment.edit(data.content_object.id),
    data,
  );
